// extracted by mini-css-extract-plugin
export var footer = "footer_TlAZsiqQiFGQyiDbOpJh";